import type {
  AccountAddress,
  AssetNamespace,
  AssetReference,
  ChainNamespace,
} from "./types";

/**
 * Normalize asset reference based on chain namespace
 * - Solana and Sui coin types: preserve exact case
 * - EVM (eip155), Starknet, Cosmos: lowercase (hex/bech32 are case-insensitive)
 */
export const normalizeAssetReference = (
  namespace: ChainNamespace | AssetNamespace,
  assetReference: AssetReference,
): string => {
  if (
    namespace === "solana" ||
    namespace === "sui" ||
    namespace === "coin"
  ) {
    return assetReference;
  }
  return assetReference.toLowerCase();
};

export const normalizeAccountAddress = (
  chainNamespace: ChainNamespace,
  accountAddress: AccountAddress,
): string => {
  if (chainNamespace === "solana") {
    return accountAddress;
  }
  return accountAddress.toLowerCase();
};
